import React, { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import PanelSidebar from "../../components/panel/PanelSidebar";
import {
  filterNavSections,
  getDoctorNavSections,
  getDoctorProfileItem,
  DOCTOR_NAV_OPTIONS,
} from "../../config/navigation";
import { PANEL, PANEL_PRIMITIVE } from "../../design-system/panel/panelTokens";
import DoctorService from "../../services/doctorService";
import { DOCTOR_INFO_UPDATED_EVENT } from "../../utils/doctorInfoEmitter";

/** Doktor panel sidebar — tenant ile aynı PanelSidebar kabuğu */
export default function SidebarDoctor(props) {
  const { t } = useTranslation("sidebar");
  const [doctorInfo, setDoctorInfo] = useState(null);
  const doctorService = useMemo(() => new DoctorService(), []);

  useEffect(() => {
    const applyDoctorInfo = (info) => {
      const normalizedDoctor = info?.doctor || info || {};
      const normalizedPermissions =
        info?.permissions ||
        info?.doctor?.permissions ||
        info?.permission ||
        {};
      setDoctorInfo({ doctor: normalizedDoctor, permissions: normalizedPermissions });
    };

    const fetchDoctorInfo = async () => {
      try {
        const info = await doctorService.getDoctorInfo();
        applyDoctorInfo(info);
      } catch (error) {
        console.error("Error fetching doctor info:", error);
      }
    };

    const handleDoctorInfoUpdated = (event) => {
      if (event.detail) {
        applyDoctorInfo(event.detail);
      } else {
        fetchDoctorInfo();
      }
    };

    fetchDoctorInfo();
    window.addEventListener(DOCTOR_INFO_UPDATED_EVENT, handleDoctorInfoUpdated);
    return () => {
      window.removeEventListener(DOCTOR_INFO_UPDATED_EVENT, handleDoctorInfoUpdated);
    };
  }, [doctorService]);

  const doctorRole = doctorInfo?.doctor?.role;
  const isIndividualDoctor = doctorInfo?.doctor?.tenant_type === 'individual_doctor' && doctorRole === 'admin';
  const doctorPermissions = doctorInfo?.permissions || {};
  const canViewPermissionGroups =
    doctorRole === "admin" ||
    doctorPermissions?.can_own_permission_groups_view === true ||
    doctorPermissions?.can_permission_groups_view === true;
  const canViewClinicalMeasurements = 
    doctorRole === "admin" ||
    doctorPermissions?.can_clinical_measurements_view === true ||
    doctorPermissions?.can_own_clinical_measurements_view === true;

  const navSections = useMemo(
    () =>
      filterNavSections(
        getDoctorNavSections(t, { canViewPermissionGroups, canViewClinicalMeasurements, isIndividualDoctor })
      ),
    [t, canViewPermissionGroups, canViewClinicalMeasurements, isIndividualDoctor]
  );

  const profileItem = useMemo(() => getDoctorProfileItem(t), [t]);

  return (
    <PanelSidebar
      {...props}
      navSections={navSections}
      profileItem={profileItem}
      pathOptions={DOCTOR_NAV_OPTIONS}
      showSectionLabels
      brand={{
        collapsedPrimary: "P",
        collapsedAccent: "M",
        titlePrimary: "Patient",
        titleAccent: "Mesh",
        subtitle: t("doctorPanelTagline"),
        mobileTitle: t("menu"),
        mobileSubtitle: t("quickAccessToDoctorTools"),
        titleColor: PANEL.text.primary,
        accentColor: PANEL_PRIMITIVE.tealAccent,
      }}
    />
  );
}
